<div class="row">
    <div class="col-sm-12 search-results p-0">
        <core-spinner name="search"></core-spinner>

        @if (showNoResults()) {
            <div class="search-results__no-results">
                <p
                    [innerText]="
                        'We\'ve not found any content related to your search. Please try again.' | translate
                    "></p>
            </div>
        }

        @if (isSearching && !showNoResults()) {
            <div class="search-results__results">
                <div
                    [hidden]="isSearchModalLoading && hasResults()"
                    class="page-loader page-loader--search-modal text-center">
                    <div class="loader"></div>
                </div>

                @if ((faq$ | async)?.resource; as faq) {
                    <h2 class="search-results__subheading">{{ 'Top FAQ' | translate }}</h2>
                    <core-block-ai-faq [faq]="faq"></core-block-ai-faq>
                }

                @if (hasResults()) {
                    <h2 class="search-results__subheading">{{ 'Results' | translate }}</h2>
                    <ul class="search-results__list">
                        @for (
                            result of results | slice: 0 : resultsSlice;
                            track trackByFn($index, result);
                            let i = $index
                        ) {
                            <li class="search-results__item w-100">
                                <a
                                    (click)="navigateToSearchResultsLink(result)"
                                    (keydown.enter)="navigateToSearchResultsLink(result)"
                                    [core-analytics]="{ action: 'Follow result', category: 'SEARCH' }"
                                    [ngClass]="{ active: activeResult === i }"
                                    class="search-results__link"
                                    href="javascript:void(0)">
                                    <!-- Page Icon -->
                                    @if (!result.isDownload) {
                                        @if (!isResultTagged(result)) {
                                            <svg
                                                class="search-results__item-icon"
                                                height="20"
                                                viewBox="0 0 16 20"
                                                width="24"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M4 16H12V14H4V16ZM4 12H12V10H4V12ZM2 20C1.45 20 0.979333 19.8043 0.588 19.413C0.196 19.021 0 18.55 0 18V2C0 1.45 0.196 0.979 0.588 0.587C0.979333 0.195667 1.45 0 2 0H10L16 6V18C16 18.55 15.8043 19.021 15.413 19.413C15.021 19.8043 14.55 20 14 20H2ZM9 7V2H2V18H14V7H9Z" />
                                            </svg>
                                        }
                                        <!-- Hash tag icon (for tagged results) -->
                                        @if (isResultTagged(result)) {
                                            <svg
                                                class="search-results__item-icon"
                                                fill="none"
                                                height="16"
                                                viewBox="0 0 18 16"
                                                width="24"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M3 16L4 12H0.5L1 10H4.5L5.5 6H1.5L2 4H6L7 0H9L8 4H12L13 0H15L14 4H17.5L17 6H13.5L12.5 10H16.5L16 12H12L11 16H9L10 12H6L5 16H3ZM6.5 10H10.5L11.5 6H7.5L6.5 10Z" />
                                            </svg>
                                        }
                                    }
                                    @if (result.isDownload) {
                                        <svg
                                            class="search-results__item-icon"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            width="24"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <mask
                                                height="24"
                                                id="mask0_330_1167"
                                                maskUnits="userSpaceOnUse"
                                                style="mask-type: alpha"
                                                width="24"
                                                x="0"
                                                y="0">
                                                <rect height="24" width="24" />
                                            </mask>
                                            <g mask="url(#mask0_330_1167)">
                                                <path
                                                    d="M6 20C5.45 20 4.97933 19.8043 4.588 19.413C4.196 19.021 4 18.55 4 18V15H6V18H18V15H20V18C20 18.55 19.8043 19.021 19.413 19.413C19.021 19.8043 18.55 20 18 20H6ZM12 16L7 11L8.4 9.55L11 12.15V4H13V12.15L15.6 9.55L17 11L12 16Z" />
                                            </g>
                                        </svg>
                                    }
                                    <span [innerHTML]="result.name"></span>
                                    <svg
                                        class="search-control-icon"
                                        fill="none"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        width="24"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <rect
                                            fill="#ECF2F3"
                                            height="24"
                                            transform="rotate(-180 24 24)"
                                            width="24"
                                            x="24"
                                            y="24" />
                                        <mask
                                            height="23"
                                            id="mask0_901_854"
                                            maskUnits="userSpaceOnUse"
                                            style="mask-type: alpha"
                                            width="23"
                                            x="0"
                                            y="1">
                                            <rect
                                                fill="#D9D9D9"
                                                height="16"
                                                transform="rotate(-45 0 12.3137)"
                                                width="16"
                                                y="12.3137" />
                                        </mask>
                                        <g mask="url(#mask0_901_854)">
                                            <path
                                                d="M13.8713 14.871L7.2716 14.871L9.42828 17.0277L8.48547 17.9705L4.71423 14.1993L8.48547 10.428L9.42828 11.3709L7.25982 13.5393L12.5395 13.5393L12.5395 6.37396L13.8713 6.38575L13.8713 14.871Z"
                                                fill="#1C1B1F" />
                                        </g>
                                    </svg>
                                </a>
                            </li>
                        }
                    </ul>
                }

                <a
                    (click)="closeModal()"
                    [core-analytics]="{ action: 'View all results', category: 'SEARCH' }"
                    [innerText]="'View all results' | translate"
                    [routerLink]="searchUrlWithZone()"
                    class="btn btn-primary search-results__view-all"></a>

                @if (!isTouchDevice()) {
                    <div class="search-results__controls">
                        <div class="select-control">
                            <svg
                                class="search-control-icon"
                                fill="none"
                                height="24"
                                viewBox="0 0 24 24"
                                width="24"
                                xmlns="http://www.w3.org/2000/svg">
                                <rect
                                    fill="#ECF2F3"
                                    height="24"
                                    transform="rotate(-180 24 24)"
                                    width="24"
                                    x="24"
                                    y="24" />
                                <mask
                                    height="23"
                                    id="mask0_901_854"
                                    maskUnits="userSpaceOnUse"
                                    style="mask-type: alpha"
                                    width="23"
                                    x="0"
                                    y="1">
                                    <rect
                                        fill="#D9D9D9"
                                        height="16"
                                        transform="rotate(-45 0 12.3137)"
                                        width="16"
                                        y="12.3137" />
                                </mask>
                                <g mask="url(#mask0_901_854)">
                                    <path
                                        d="M13.8713 14.871L7.2716 14.871L9.42828 17.0277L8.48547 17.9705L4.71423 14.1993L8.48547 10.428L9.42828 11.3709L7.25982 13.5393L12.5395 13.5393L12.5395 6.37396L13.8713 6.38575L13.8713 14.871Z"
                                        fill="#1C1B1F" />
                                </g>
                            </svg>
                            <span class="search-control-text">{{ 'to select' | translate }}</span>
                        </div>

                        <div class="navigate-control">
                            <svg
                                class="search-control-icon"
                                fill="none"
                                height="24"
                                viewBox="0 0 24 24"
                                width="24"
                                xmlns="http://www.w3.org/2000/svg">
                                <rect
                                    fill="#ECF2F3"
                                    height="24"
                                    transform="rotate(-180 24 24)"
                                    width="24"
                                    x="24"
                                    y="24" />
                                <mask
                                    height="16"
                                    id="mask0_901_849"
                                    maskUnits="userSpaceOnUse"
                                    style="mask-type: alpha"
                                    width="16"
                                    x="4"
                                    y="4">
                                    <rect
                                        fill="#D9D9D9"
                                        height="16"
                                        transform="rotate(-180 20 20)"
                                        width="16"
                                        x="20"
                                        y="20" />
                                </mask>
                                <g mask="url(#mask0_901_849)">
                                    <path
                                        d="M12.6667 6.66665L12.6667 14.7833L16.4 11.05L17.3334 12L12 17.3333L6.66671 12L7.60004 11.05L11.3334 14.7833L11.3334 6.66665L12.6667 6.66665Z"
                                        fill="#1C1B1F" />
                                </g>
                            </svg>

                            <svg
                                class="search-control-icon"
                                fill="none"
                                height="24"
                                viewBox="0 0 24 24"
                                width="24"
                                xmlns="http://www.w3.org/2000/svg">
                                <rect fill="#ECF2F3" height="24" width="24" />
                                <mask
                                    height="16"
                                    id="mask0_901_842"
                                    maskUnits="userSpaceOnUse"
                                    style="mask-type: alpha"
                                    width="16"
                                    x="4"
                                    y="4">
                                    <rect fill="#D9D9D9" height="16" width="16" x="4" y="4" />
                                </mask>
                                <g mask="url(#mask0_901_842)">
                                    <path
                                        d="M11.3333 17.3334V9.21669L7.59996 12.95L6.66663 12L12 6.66669L17.3333 12L16.4 12.95L12.6666 9.21669V17.3334H11.3333Z"
                                        fill="#1C1B1F" />
                                </g>
                            </svg>
                            <span class="search-control-text">{{ 'to navigate' | translate }}</span>
                        </div>

                        <div class="escape-control">
                            <div class="escape-control__box">
                                <span class="escape-control__text">{{ 'esc' | translate }}</span>
                            </div>
                            <span class="search-control-text">{{ 'to close' | translate }}</span>
                        </div>
                    </div>
                }
            </div>
        }
    </div>
</div>
